import { UPDATE_CREATIVES_CAMPAIGN_NAME } from './actionTypes';

export default updatedCampaign => ({ type: UPDATE_CREATIVES_CAMPAIGN_NAME, payload: updatedCampaign });
